import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '../../services/auth.service';
import { NotificationService } from '../../services/notification.service';
import { ErrorHelperService } from '../../services/error-helper.service';

@Component({
  selector: 'app-registration',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, RouterModule],
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent {
  registrationForm: FormGroup;
  isSubmitted = false;
  isLoading = false;
  registrationSuccess = false;
  generalError: string = '';
  showGeneralError: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private notificationService: NotificationService,
    private errorHelperService: ErrorHelperService
  ) {
    this.registrationForm = this.fb.group({
      dealerCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(50)]]
    });
  }

  onSubmit(): void {
    this.isSubmitted = true;
    this.showGeneralError = false;

    if (this.registrationForm.valid) {
      this.isLoading = true;
      const { dealerCode, email } = this.registrationForm.value;

      this.authService.register(dealerCode, email)
        .then((success: boolean) => {
          this.isLoading = false;
          if (success) {
            this.registrationSuccess = true;
            this.registrationForm.reset();
            this.isSubmitted = false;
          }
        })
        .catch((error: Error) => {
          this.isLoading = false;
          const message = this.errorHelperService.extractBackendMessage(error);
          this.handleRegistrationError(message);
        });
    }
  }

  private handleRegistrationError(errorMessage: string): void {
    this.showGeneralError = true;
    this.generalError = errorMessage;
    // if (errorMessage.includes('409') || errorMessage.includes('already') || errorMessage.includes('esistente')) {
    //   this.generalError = 'REGISTRATION.ERROR.GENERAL.ALREADY_EXISTS';
    // } else if (errorMessage.includes('rate limit') || errorMessage.includes('429')) {
    //   this.generalError = 'REGISTRATION.ERROR.GENERAL.RATE_LIMIT';
    // } else if (errorMessage.includes('400') || errorMessage.includes('Bad Request')) {
    //   this.generalError = 'REGISTRATION.ERROR.GENERAL.BAD_REQUEST';
    // } else if (errorMessage.includes('network') || errorMessage.includes('Network')) {
    //   this.generalError = 'REGISTRATION.ERROR.GENERAL.NETWORK_ERROR';
    // } else if (errorMessage.includes('500') || errorMessage.includes('server')) {
    //   this.generalError = 'REGISTRATION.ERROR.GENERAL.SERVER_ERROR';
    // } else {
    //   this.generalError = 'REGISTRATION.ERROR.GENERAL.UNKNOWN_ERROR';
    // }
  }

  getErrorMessage(field: string): string {
    const control = this.registrationForm.get(field);
    const key = this.fieldKey(field);

    if (control?.hasError('required')) {
      return `REGISTRATION.ERROR.${key}.REQUIRED`;
    }
    if (control?.hasError('email')) {
      return `REGISTRATION.ERROR.${key}.INVALID`;
    }
    if (control?.hasError('minlength')) {
      return `REGISTRATION.ERROR.${key}.MIN_LENGTH`;
    }
    if (control?.hasError('maxlength')) {
      return `REGISTRATION.ERROR.${key}.MAX_LENGTH`;
    }
    return '';
  }

  private fieldKey(field: string): string {
    // dealerCode -> DEALER_CODE, email -> EMAIL
    return field.replace(/([A-Z])/g, '_$1').toUpperCase();
  }

  hasError(field: string): boolean {
    const control = this.registrationForm.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched || this.isSubmitted));
  }

  hasGeneralError(): boolean {
    return this.showGeneralError;
  }

  getGeneralError(): string {
    return this.generalError;
  }

  onInputChange(): void {
    if (this.showGeneralError) {
      this.showGeneralError = false;
    }
  }

  closeSuccessModal(): void {
    this.registrationSuccess = false;
    this.router.navigate(['/login']);
  }
}
